import handler from 'api/handler';

const prefix = '/public/spirituality';

const methods = {
  addSpirituality: args => handler({ method: 'post', url: prefix + '/add', args }),
  updateSpirituality: args => handler({ method: 'put', url: prefix + '/update', args }),
  fetchAllSpirituality: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  fetchPurohitOnCall: args => handler({ method: 'get', url: prefix + '/purohit', args }),
  submitPurohitOnCall: args => handler({ method: 'post', url: prefix + '/purohit', args, isFile: true }),
};

export default methods;
